import React from 'react'

import EcsButton from '../../components/Button'

export default({clinic}) => {
  return (
    <div>
      {
        clinic.appointmentUrl &&
        <div className="home-clinic-button">
          <EcsButton label={"Appointments"} url={clinic.appointmentUrl} local={false} />
        </div>
      }
      {
        clinic.payUrl &&
        <div className="home-clinic-button">
          <EcsButton label={"Pay Bill"} url={clinic.payUrl} local={false} />
        </div> 
      }
      {
        clinic.buyContactsUrl &&
        <div className="home-clinic-button">
          <EcsButton label={"Order Contacts"} url={clinic.buyContactsUrl} local={false} />
        </div>
      }
    </div>
  )
}